import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=73e8e8da&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=73e8e8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e8e8da",
  null
  
)

export default component.exports